var _style, _polygon, _g, _path, _defs, _path2, _path3, _path4, _path5, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptaMaxSecondaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1037.8 210.4",
    style: {
      enableBackground: "new 0 0 1037.8 210.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000100365394493118942020000015407877048662487738_);}\n\t.st4{clip-path:url(#SVGID_00000160902852422899417480000005213462940038726300_);}\n\t.st5{fill:url(#SVGID_00000183207455988690635240000003077888670734570910_);}\n\t.st6{fill:url(#SVGID_00000106127844200662538640000016668774863381750150_);}\n\t.st7{fill:#DDDDDD;}\n\t.st8{fill:#9B9B9B;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1005.2,184.1 32.6,184.1 0,24.1 1037.8,24.1 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opta"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271,88.5c-6.8,0-12.4,0.9-16.8,2.6l-3.4,1.2v59h12.6v-17.8c2.2,0.5,4.4,0.7,6.6,0.8c6.4,0,11.2-1.5,14.4-4.6 s4.8-7.6,4.8-13.4v-10.5c0-5.6-1.5-9.8-4.5-12.8S277.2,88.5,271,88.5L271,88.5z M276.5,116.2c0,4.6-2.5,6.8-7.6,6.8 c-1.9,0-3.7-0.2-5.6-0.5v-22.2l0.5-0.1c0.9-0.2,1.9-0.4,2.8-0.5c0.9-0.1,1.9-0.1,2.8-0.1c4.7,0,7,2,7,6.1V116.2L276.5,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.2,100.9l3.7-11.2h-10.4v-10H298v10h-7.5v11.2h7.5v14.5c0,3.8,0.4,6.9,1.2,9.3s2,4.3,3.6,5.7 c1.6,1.4,3.7,2.4,6.3,3c3,0.6,6.1,0.9,9.2,0.8h2v-11.6h-2c-1.2,0-2.4-0.1-3.6-0.3c-0.9-0.2-1.7-0.6-2.4-1.2 c-0.6-0.7-1.1-1.5-1.3-2.4c-0.3-1.3-0.4-2.5-0.4-3.8v-14L317.2,100.9L317.2,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,88.5c-8.8,0-14.7,2.9-17.8,8.7l-1.2,2.4l10.4,4.3l1.3-1.8c1.5-2.1,3.9-3.1,6.9-3.1 c4.3,0,6.4,2.1,6.4,6.2v1.8c-0.9-0.1-1.8-0.1-2.8-0.1s-2,0-3.1,0c-3,0-6,0.2-9,0.7c-2.5,0.5-4.5,1.2-6,2.3c-1.5,1-2.7,2.5-3.4,4.2 c-0.7,1.8-1.1,3.9-1.1,6.4c0,2.1,0.3,4.2,1,6.1c0.6,1.7,1.7,3.2,3.2,4.3c1.5,1.1,3.4,1.9,5.9,2.5s5.5,0.8,9.1,0.8 c7.2,0,12.4-0.8,15.7-2.2c0.1-0.1,0.3-0.1,0.6-0.3s0.6-0.3,1-0.5c0.4-0.2,0.9-0.4,1.4-0.7v-24.6C360.7,94.3,354.5,88.5,342.1,88.5 L342.1,88.5z M348.1,124.1l-0.8,0.1c-0.9,0.1-1.8,0.2-2.7,0.2c-1.1,0.1-2.3,0.1-3.8,0.1c-2.2,0-3.6-0.3-4.4-1 c-0.8-0.7-1.2-1.7-1.2-3s0.4-2.3,1.2-2.9c0.8-0.7,2.3-1,4.5-1c0.3,0,0.8,0,1.5,0c0.7,0,1.4,0,2.2,0s1.4,0,2.1,0s1,0,1.2,0 L348.1,124.1L348.1,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,78.6c-4.3-3.9-10.4-5.9-18.2-5.9c-7.8,0-13.9,2-18.1,5.9s-6.4,9.4-6.4,16.5v16.8c0,7,2.1,12.5,6.4,16.5 c4.3,3.9,10.3,5.9,18.1,5.9s13.9-2,18.2-5.9c4.3-3.9,6.4-9.4,6.4-16.5V95C246.9,88,244.8,82.5,240.5,78.6L240.5,78.6z M233.4,112.1 c0,6.5-3.7,9.7-11.1,9.7c-3.6,0-6.3-0.8-8.1-2.4c-1.9-1.6-2.8-4.1-2.8-7.3V94.8c0-3.2,0.9-5.7,2.8-7.3c1.9-1.6,4.6-2.4,8.1-2.4 c7.4,0,11.1,3.2,11.1,9.7V112.1L233.4,112.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.9685,
    y1: 14423.0449,
    x2: 170.6485,
    y2: 14444.7148,
    gradientTransform: "matrix(1 0 0 1 0 -14325.3496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FAA51A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F06424"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.3,58.8c-3.1-2.8-6.7-5.1-10.6-6.7l-7.4,22.2c0.8,0.4,1.6,1,2.2,1.6c1.1,1.1,4.2,3.9,4.2,12.9v30.6 c0,9.1-3,11.9-4.2,12.9c-4.1,3.8-11.8,4.6-17.4,4.6c-1.8,0-3.7-0.1-5.5-0.3l-7.4,22.3c4.3,0.8,8.6,1.2,12.9,1.1 c14.3,0,25.4-3.6,33.1-10.8c7.8-7.2,11.7-17.1,11.6-30V88.8C167.9,76,164,66,156.3,58.8L156.3,58.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094617611113929648170000014466839473620991159_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.7964,
    y1: 14414.1416,
    x2: 142.3464,
    y2: 14435.7617,
    gradientTransform: "matrix(1 0 0 1 0 -14325.3496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E07AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#E5202F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094617611113929648170000014466839473620991159_)"
    },
    d: "M105.9,132.3c-1.1-1.1-4.2-3.9-4.2-12.9 V88.8c0-9.1,3-11.9,4.2-12.9c3.3-3.1,9.1-4.6,17.3-4.6c1.6,0,3.4,0.1,5.2,0.2l7.4-22.4c-4.2-0.8-8.4-1.1-12.7-1.1 c-14.2,0-25.2,3.6-33,10.8C82.4,66,78.5,76,78.5,88.8v30.6c0,12.8,3.9,22.8,11.7,30c3,2.8,6.5,5,10.2,6.6l7.4-22.2 C107.1,133.2,106.5,132.8,105.9,132.3L105.9,132.3z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000006681612842357741520000001353618207386493575_",
    d: "M692.3,64.2h36.6v79.9h-27.5v-40.3l-19.8,35.1h-24.9 l-21.8-38.1v43.3h-27.5V64.2h38.3l23.5,41.1L692.3,64.2L692.3,64.2z M815.1,144.1l-4.9-10.7h-38.9l-4.9,10.7H737l40.7-80h26.1 l40.7,80H815.1L815.1,144.1z M780.3,113.6h20.8l-10.3-22.5L780.3,113.6L780.3,113.6z M958.5,144.1h-35.6L903,119.7l-19.2,24.4 h-35.4l35.7-41l-33.4-38.9h35.5l17.7,21.9l16.8-21.9h35.5l-33.4,38.5L958.5,144.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000201597712355096800000012922536202730794409_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006681612842357741520000001353618207386493575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000201597712355096800000012922536202730794409_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M692.3,64.2h36.6v79.9h-27.5v-40.3l-19.8,35.1h-24.9l-21.8-38.1v43.3h-27.5V64.2h38.3l23.5,41.1L692.3,64.2 L692.3,64.2z M815.1,144.1l-4.9-10.7h-38.9l-4.9,10.7H737l40.7-80h26.1l40.7,80H815.1L815.1,144.1z M780.3,113.6h20.8l-10.3-22.5 L780.3,113.6L780.3,113.6z M958.5,144.1h-35.6L903,119.7l-19.2,24.4h-35.4l35.7-41l-33.4-38.9h35.5l17.7,21.9l16.8-21.9h35.5 l-33.4,38.5L958.5,144.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155126116389814021390000007115897433714456493_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.83,
    y1: 26.21,
    x2: 782.83,
    y2: 113.93,
    gradientTransform: "matrix(1 0 0 -1 0 212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDDDDD"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000155126116389814021390000007115897433714456493_)"
    },
    cx: 782.8,
    cy: 141.9,
    rx: 310.3,
    ry: 43.9
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.9,209.8c-31.2-10.8-72-41.2-84.2-91.5c-14.2-58.2-9.3-90-9-91.3l0.5-3.1l3-0.9c0.5-0.1,11.3-3.3,42.1-11.2 c32.6-8.4,47.6-11.5,48.3-11.6l1-0.2l1,0.2c0.6,0.1,15.6,3.2,48.3,11.6c30.8,7.9,41.7,11.1,42.1,11.2l3,0.9l0.5,3.1 c0.2,1.3,5.1,33-9,91.3c-12.2,50.3-53,80.8-84.2,91.5l-1.6,0.6L467.9,209.8L467.9,209.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469.5,5.1c0,0,15.1,3,48,11.5c31,8,41.9,11.2,41.9,11.2s5.1,31.4-9,89.3c-11.4,46.8-48.7,76.8-81,88 c-32.3-11.1-69.6-41.2-81-88c-14.1-57.9-9-89.3-9-89.3s10.9-3.2,41.9-11.2C454.4,8.1,469.5,5.1,469.5,5.1L469.5,5.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060026238342518919450000001644081434450720940_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.5468,
    y1: 200.01,
    x2: 469.5468,
    y2: 14.06,
    gradientTransform: "matrix(1 0 0 -1 0 212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F06424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5202F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060026238342518919450000001644081434450720940_)"
    },
    d: "M469.5,197.9 c-15.7-5.8-31.1-15.8-43.6-28.2c-7.3-7.3-13.6-15.4-18.7-24.1c-5.5-9.4-9.6-19.5-12.2-30.1c-3.9-16-8.7-40.2-9.6-64.4 c-0.3-8.3,0-14.4,0.3-18c5.7-1.6,17.3-4.8,37.4-9.9c26.9-6.9,42-10.2,46.3-11.2c4.4,0.9,19.4,4.2,46.3,11.2 c20,5.2,31.7,8.3,37.4,9.9c0.3,3.7,0.5,9.7,0.3,18c-0.5,13.3-2.5,35.4-9.6,64.4c-2.6,10.6-6.7,20.7-12.2,30.1 c-5.1,8.7-11.3,16.8-18.7,24.1C500.7,182.2,485.3,192.1,469.5,197.9L469.5,197.9z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.5,199.7l-0.6-0.2c-15.9-5.9-31.6-16.1-44.2-28.6c-7.4-7.4-13.8-15.6-18.9-24.4 c-5.6-9.6-9.8-19.8-12.4-30.6c-3.9-16.1-8.8-40.4-9.6-64.8c-0.3-8.4,0-14.5,0.3-18.2l0.1-1.2l1.1-0.3c5.2-1.4,16.9-4.6,37.4-9.9 c27.1-7,42.4-10.3,46.4-11.2l0.4-0.1l0.4,0.1c4,0.9,19.3,4.2,46.4,11.2c20.5,5.3,32.2,8.5,37.4,9.9l1.1,0.3l0.1,1.2 c0.3,3.7,0.6,9.8,0.3,18.2c-0.5,13.4-2.5,35.6-9.6,64.8c-2.6,10.7-6.8,21-12.3,30.6c-5.2,8.8-11.5,17-18.9,24.4 c-12.6,12.6-28.3,22.7-44.2,28.6L469.5,199.7L469.5,199.7z M387.4,34.4c-0.2,3.7-0.4,9.3-0.2,16.7c0.8,24.1,5.6,48.1,9.5,64.1 c2.5,10.4,6.6,20.4,12,29.6c5,8.5,11.2,16.5,18.4,23.7c12.1,12.1,27.1,21.9,42.4,27.6c15.2-5.8,30.3-15.5,42.4-27.6 c7.2-7.2,13.4-15.2,18.4-23.7c5.4-9.3,9.5-19.2,12-29.6c7-28.9,9-50.8,9.5-64.1c0.3-7.4,0.1-13-0.2-16.7c-5.7-1.6-17.1-4.7-36.2-9.6 C489.2,18,474,14.7,469.6,13.7c-4.5,1-19.6,4.3-45.9,11.1C404.6,29.7,393.1,32.8,387.4,34.4L387.4,34.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484,75.4 469.5,30.9 455.1,75.4 408.3,75.4 421.2,84.8 462.8,84.8 469.5,64.1 476.3,84.8 518,84.8  530.8,75.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "512.6,88.6 493.8,88.6 480.6,98.2 487.5,119.3 469.5,106.3 460.6,112.8 469.5,119.9 507.4,147.4  493,102.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "451.6,119.3 458.5,98.2 445.3,88.6 426.5,88.6 446.2,102.9 431.7,147.4 466.8,121.9 460.4,112.9 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "460.6,112.8 460.4,112.9 466.8,121.9 469.5,119.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptaMaxSecondaryLogo);
export default __webpack_public_path__ + "static/media/Opta-Max_Secondary-Logo.95d1e9e10a82b04de871007253a3f387.svg";
export { ForwardRef as ReactComponent };